import React, { useState } from "react";
import { Menu, X, CalendarCheck } from "lucide-react";
import { navLinks } from "../mock";

const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 bg-navy text-white">
      <div className="bg-navy-3">
        <div className="max-w-6xl mx-auto px-4 flex items-center justify-between h-10">
          <a href="#contact" className="inline-flex items-center gap-2 bg-gold hover:bg-gold-dark transition-colors text-navy text-[11px] font-bold tracking-widest uppercase px-4 py-1.5">
            <CalendarCheck className="w-3.5 h-3.5" /> Book Consultation
          </a>
          <span className="hidden sm:block text-[11px] tracking-widest uppercase text-white/50">{"Washington, D.C. \u2022 Virginia \u2022 Maryland \u2022 Florida \u2022 Delaware"}</span>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-4 flex items-center justify-between h-20">
        <a href="#top" className="flex flex-col leading-none">
          <span className="font-head text-xl sm:text-2xl font-bold tracking-wide">
            ADAM A. ALBABA, <span className="text-gold">MD</span>
          </span>
          <span className="text-[10px] sm:text-[11px] tracking-[0.22em] text-white/50 uppercase mt-1">
            {"Trauma \u2022 Foot & Ankle \u2022 Sports Medicine"}
          </span>
        </a>
        <nav className="hidden lg:flex items-center gap-7">
          {navLinks.map((l) => (
            <a key={l.label} href={l.href} className="text-[12px] font-semibold uppercase tracking-widest text-white/80 hover:text-gold transition-colors">{l.label}</a>
          ))}
        </nav>
        <button className="lg:hidden text-white" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
        </button>
      </div>
      {open && (
        <nav className="lg:hidden bg-navy-2 border-t border-white/10 flex flex-col px-6 py-3">
          {navLinks.map((l) => (
            <a key={l.label} href={l.href} onClick={() => setOpen(false)} className="py-3 text-xs font-semibold uppercase tracking-widest text-white/80 border-b border-white/5 hover:text-gold">{l.label}</a>
          ))}
        </nav>
      )}
    </header>
  );
};

export default Header;
